<template>
  <v-btn
    elevation="2"
    v-bind="$props"
    v-on="$listeners"
    class="white--text send"
    ><slot></slot
  ></v-btn>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.send {
  background-color: #0f0f0f !important;
  transition: 0.3s ease-in;
  font-size: clamp(0.7rem, 1vw, 1rem);
  &:hover {
    background-color: #e61e30 !important;
  }

  &:disabled {
    opacity: 0.3;
  }
}
</style>
